import request from '../request';

export type ConsultationSubmitPayload = {
  companyName: string;
  contactName: string;
  phone: string;
  email: string;
  content: string;
  agreePrivacy: boolean;
};

export type ConsultationSubmitResult = {
  code: number;
  msg: string | null;
  data?: unknown;
};

/** POST /jdx/mini/consultation/submit */
export function submitConsultation(
  data: ConsultationSubmitPayload,
): Promise<ConsultationSubmitResult> {
  return request.post<ConsultationSubmitResult, ConsultationSubmitPayload>({
    url: '/jdx/mini/consultation/submit',
    data,
  });
}
